<template>
  <div></div>
</template>

<script>
import { CLIENT_API_URL } from '../../../constants/Environment';
import html2pdf from 'html2pdf.js';
import printJS from 'print-js';
import axios from 'axios';

export default {
  name: 'PrintOrder',

  created() {
    this.$root.$on('print-order-pdf', this.printPDF);
  },

  beforeDestroy() {
    this.$root.$off('print-order-pdf');
  },

  methods: {
    async printPDF(orderId, isWithDiscount) {
      let objectToPrint = await this._fetchObjectToPrint(
        orderId,
        'order-print',
        isWithDiscount
      );
      var opt = {
        html2canvas: { y: 0, scrollY: 0 },
        filename: objectToPrint.fileName + '.pdf'
      };
      html2pdf()
        .set(opt)
        .from(objectToPrint.htmlData)
        .outputPdf()
        .then(function(pdf) {
          printJS({
            printable: btoa(pdf),
            type: 'pdf',
            base64: true
          });
        });
    },

    async _fetchObjectToPrint(orderId, url, isWithDiscount) {
      let objectToPrintData;
      try {
        objectToPrintData = await axios.get(
          `${CLIENT_API_URL}/orders/${orderId}/${url}?discounts=${isWithDiscount}`
        );
      } catch (error) {
        console.error(
          'There was an error while retrieving the object to print' + error
        );
      }
      return objectToPrintData.data;
    }
  }
};
</script>
